export default __webpack_public_path__ + "static/media/USDD.429ce831.png";